<template>
    <div v-if="statusOptions">
        <div class="row mt-0">
            <div class="col-3">
                <app-input-select :options="formatosOptions" :disabled="false" v-model="data.formato" label="Formato"
                    id="formato" :notDefault="true" @input="updateOutros" />
            </div>
            <div class="col-3">
                <app-input-text label="Tipo de entrega" :icon="true" :contentType="1" id="tipo_de_entrega"
                    :value="data.tipo_de_entrega" @input="updateOutros" @change="inputValueChange" />
            </div>
            <div class="col-2">
                <app-input-text label="Qtda total" :icon="true" :contentType="12" id="qtda"
                    :value="data.qtda.toString()" @input="updateOutros" @change="inputValueChange" />
            </div>
            <div class="col-2">
                <app-input-text label="Qtda templatizados" :icon="true" :contentType="12" id="qtda_templatizada"
                    :value="data.qtda_templatizada.toString()" @input="updateOutros" @change="inputValueChange" />
            </div>
            <div class="col-2">
                <app-input-select :options="versionamentosOptions" :disabled="false" v-model="data.versionamento"
                    label="Versionamento" :notDefault="true" id="versionamento" @input="updateOutros" />
            </div>
            <div class="col-3">
                <app-input-select :options="statusOptions" :disabled="false" v-model="data.status" label="Status"
                    id="status" :notDefault="true" @input="updateOutros" />
            </div>
            <div class="col-3">
                <app-input-date :value="data.data_entrada_briefing" id="data_entrada_briefing"
                    label="Data entrada briefing" @input="updateOutros" />
            </div>
            <div class="col-3">
                <app-input-date :value="data.data_entrada" id="data_entrada" label="Data entrada"
                    @input="updateOutros" />
            </div>
            <div class="col-3">
                <app-input-date :value="data.data_saida" id="data_saida" label="Data Saída" @input="updateOutros" />
            </div>
            <div class="col-12">
                <button class="btn btn-primary bg-gray" @click="handlePropertie">
                    <template v-if="!isSending">Adicionar</template>
                    <template v-else>Adicionando...</template>
                </button>
            </div>
        </div>
    </div>
</template>
<script>

import { status, versionamentos, formatos } from '../../../data/data-static.js'
import { mapActions, mapMutations } from "vuex";
import AppInputSelect from "@/components/AppInputSelect/AppInputSelect.vue";
import AppInputText from "@/components/AppInputText/AppInputTextFormats.vue";
import AppInputDate from "@/components/AppInputDate/AppInputDate.vue";
export default {
    props: {
        task_id: {
            type: [String, Number],
            required: true
        },
        id: {
            type: [String, Number],
            required: false
        },
    },
    components: {
        AppInputSelect,
        AppInputText,
        AppInputDate
    },
    computed: {
        statusOptions() {
            return status
        },
        versionamentosOptions() {
            return versionamentos
        },
        formatosOptions() {
            return formatos
        }
    },
    data() {
        return {
            data: {
                'formato': null,
                'tipo_de_entrega': null,
                'qtda': 0,
                'qtda_templatizada': 0,
                'versionamento': null,
                'status': null,
                'data_entrada_briefing': null,
                'data_entrada': null,
                'data_saida': null
            },
            isSending: false
        }
    },
    methods: {
        ...mapActions([
            "showMessage"
        ]),
        updateOutros(v = null, n = null) {
            if (v === null) {
                this.data[n] = null;
            }
            else {
                this.data[n] = v;
            }

        },
        inputValueChange() {
            console.log('inputValueChange')
        },
        async handlePropertie() {

            if (this.data.qtda_templatizada > this.data.qtda) {
                this.showMessage({
                    title: 'Templatizadas maior que o número de peças.',
                    css: "bg-danger"
                });
                return;
            }

            if (this.data.formato == null || this.data.qtda == null || this.data.versionamento == null || this.data.status == null) {
                this.showMessage({
                    title: "Por favor, revise os dados:",
                    text: ['Formato, Quantidade, Versionamento e Status'],
                    css: "bg-danger"
                });
                return;
            }

            const data = {
                'formato': this.data.formato,
                'tipo_de_entrega': this.data.tipo_de_entrega,
                'qtda': this.data.qtda,
                'qtda_templatizada': this.data.qtda_templatizada,
                'versionamento': this.data.versionamento,
                'status': this.data.status,
                'data_entrada_briefing': this.data.data_entrada_briefing,
                'data_entrada': this.data.data_entrada,
                'data_saida': this.data.data_saida
            };
            if (data) {
                console.log('dataaaa', data);

            }

            if (!this.isSending) {
                this.isSending = true;
                try {
                    const { url, options } = this.$getAPIHeadersFetch("POST", `task-properties-all-set/${this.task_id}`, data);
                    const response = await fetch(url, options);
                    const result = await response.json();
                    console.log('dataaaa 2', result);
                    if (result.status === 200 || result.status === 201) {
                        this.showMessage({
                            title: 'Adicionado!',
                            css: "bg-success"
                        });
                        console.log(result)
                        this.$emit("pushData", result.data);
                    }
                    else if (result.status === 400) {

                        this.showMessage({
                            title: result.message,
                            css: "bg-danger"
                        });

                    } else {

                        this.showMessage({
                            title: "Por favor, revise os dados fornecidos.",
                            text: result.errors,
                            css: "bg-danger"
                        });

                    }
                } catch (error) {
                    this.showMessage({
                        title: "Desculpe um erro aconteceu, por favor, tente novamente.",
                        css: "bg-danger"
                    });
                    console.log(error);

                } finally {
                    this.isSending = false;
                }
            }
        }
    }
}
</script>